import React, { HTMLAttributes, useState, useEffect } from "react";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import PageSection from "components/layout/PageSection";
import clsx from "clsx";
import useBackgroundStyles from "components/backgrounds/useBackgroundStyles";
import StyledButton from "components/buttons/StyledButton";
import mediaTitle from "assets/images/homePage/mediaSection/title_media.png";
import Rotate from "components/rotate/Rotate";
import Spacer from "components/Spacer";
import { IMediaPageVideo } from "apiConsumers/kenticoApiConsumer/models/mediaPage/IMediaPageVideos";
import { kenticoApi } from "apiConsumers";
import Videos from "./Videos";
import { IMediaPageScreenshot } from "apiConsumers/kenticoApiConsumer/models/mediaPage/IMediaPageScreenshots";
import Screenshots from "./Screenshots";
// import MainMailingListSubscription from "./supscription/MainMailingListSubscription";
import Scribble from "components/scribble/Scribble";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {},
        childContainer: {
            display: "flex",
            flexDirection: "column",
            [theme.breakpoints.down("sm")]: {
                alignItems: "center",
            },
        },
        mainMailingListScribble: {
            left: "-75px",
            top: "0px",
            height: "auto",
        },
        mainMailingList: {
            maxWidth: 750,
            marginRight: 28,
        },
        tabsContainer: {
            display: "flex",
        },
    });
});

type Tab = "videos" | "screenshots";

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function MediaSection(props: IProps) {
    const { className, id, ...rest } = props;
    const classes = useStyles();
    const backgrounds = useBackgroundStyles();

    const [selectedTab, setSelectedTab] = useState<Tab>("videos");

    const [videos, setVideos] = useState<IMediaPageVideo[]>([]);
    const [videosIsLoading, setVideosIsLoading] = useState<boolean>(false);
    const [videosIsError, setVideosIsError] = useState<boolean>(false);

    const [screenshots, setScreenshots] = useState<IMediaPageScreenshot[]>([]);
    const [screenshotsIsLoading, setScreenshotsIsLoading] = useState<boolean>(false);
    const [screenshotsIsError, setScreenshotsIsError] = useState<boolean>(false);

    const theme = useTheme();
    const xsScreen = useMediaQuery(theme.breakpoints.down("xs"));

    const itemsInGrid = 6;

    useEffect(() => {
        setVideosIsLoading(true);
        kenticoApi
            .getMediaPageVideos()
            .then((response) => {
                if (typeof response === "undefined") return;

                setVideos(response.videos);
                setVideosIsError(false);
            })
            .catch((err) => {
                setVideosIsError(true);
            })
            .finally(() => {
                setVideosIsLoading(false);
            });
    }, []);

    useEffect(() => {
        setScreenshotsIsLoading(true);
        kenticoApi
            .getMediaPageScreenshots()
            .then((response) => {
                if (typeof response === "undefined") return;

                setScreenshots(response.screenshots);
                setScreenshotsIsError(false);
            })
            .catch((err) => {
                setScreenshotsIsError(true);
            })
            .finally(() => {
                setScreenshotsIsLoading(false);
            });
    }, []);

    const buttonSize = xsScreen ? "small" : "medium";

    return (
        <PageSection
            classes={{
                childContainer: classes.childContainer,
                skewedSectionRoot: backgrounds.media,
            }}
            skewed
            topSeparatorVariant="secondary"
            className={clsx(className, classes.root)}
            {...rest}
        >
            <Rotate
                id={id}
                amount={-2}
                style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
            >
                <div>
                    <img src={mediaTitle} style={{ width: "100%", maxWidth: 175 }} alt="" />
                </div>
                <Spacer size={2} />
                <div className={classes.tabsContainer}>
                    <Rotate amount={1}>
                        <StyledButton
                            variant={selectedTab === "videos" ? "white" : "primary"}
                            onClick={() => setSelectedTab("videos")}
                            style={{ minWidth: xsScreen ? "unset" : 175 }}
                            size={buttonSize}
                        >
                            Videos
                        </StyledButton>
                    </Rotate>
                    <Spacer />
                    <StyledButton
                        variant={selectedTab === "screenshots" ? "white" : "primary"}
                        onClick={() => setSelectedTab("screenshots")}
                        size={buttonSize}
                    >
                        Screenshots
                    </StyledButton>
                </div>
            </Rotate>
            <Spacer size={2} />
            <div>
                {selectedTab === "videos" ? (
                    videosIsError ? (
                        <div>There has been an error fetching the videos. Please try again.</div>
                    ) : (
                        <Videos
                            numberOfItemsToDisplay={itemsInGrid}
                            isLoading={videosIsLoading}
                            videos={videos}
                        />
                    )
                ) : null}
                {selectedTab === "screenshots" ? (
                    screenshotsIsError ? (
                        <div>
                            There has been an error fetching the screenshots. Please try again.
                        </div>
                    ) : (
                        <Screenshots
                            isLoading={screenshotsIsLoading}
                            screenshots={screenshots}
                            numberOfItemsToDisplay={itemsInGrid}
                        />
                    )
                ) : null}
            </div>

            <Spacer size={4} />

            <div style={{ flex: "1 1 auto", display: "flex", justifyContent: "center" }}>
                <Scribble
                    variant="v1"
                    classes={{
                        scribbleContainer: classes.mainMailingListScribble,
                        childContainer: classes.mainMailingList,
                    }}
                >
                    {/* <MainMailingListSubscription /> */}
                </Scribble>
            </div>
        </PageSection>
    );
}
